export default theme => ({
  datagrid: {
    padding: 10,
    whiteSpace: "pre-wrap"
  },
});
